import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import ActivateEEIDialog from '@components/shared/dialogs/ActivateEEIDialog'
import Title from '@models/Title'
import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'

const ActivateEEButton = () => {
  const {
    title: { permissions, uuid, title_type },
  } = useContext(TitleContext)

  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const closeDialog = useDialogStore((s) => s.closeDialog)

  // EE books are the only type of titles that are activatable
  if (!permissions?.requires_ee_activation || title_type !== Title.Type.EE) return null

  const onClick = () => {
    openDialog('activate_eei')
  }

  const afterActivate = () => {
    closeDialog('activate_eei')
    window.location.reload()
  }

  return (
    <>
      <Button onClick={onClick}>{t('action.activate')}</Button>
      <ActivateEEIDialog titleUuid={uuid} afterActivate={afterActivate} />
    </>
  )
}

export default ActivateEEButton
